import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import DebtsTab from '../components/DebtsTab';
import { useTranslation } from '../hooks/useTranslation';
import './DebtsPage.css';

const DebtsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="debts-page">
      <Navbar />
      <div className="debts-page-content">
        <div className="debts-page-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← {t('common.back')}
          </button>
        </div>
        <DebtsTab onBack={() => {}} />
      </div>
    </div>
  );
};

export default DebtsPage;

